import getData from "@/__main__/get-data.mjs";
import { appURLs } from "@/app/constants.mjs";
import {
  QUEUE_SYMBOLS,
  SERVICES_TO_REGIONS,
} from "@/game-lol/constants/constants.mjs";
import * as GraphQLTemplates from "@/game-lol/graphql-templates.mjs";
import PlaystylesModel from "@/game-lol/models/lol-player-styles.mjs";
import QueueSymbol, {
  QUEUE_SYMBOL_TO_OBJECT,
} from "@/game-lol/utils/symbol-queue.mjs";
import { getDerivedId } from "@/game-lol/utils/util.mjs";
import { queryGQL } from "@/util/gql-formatters.mjs";

function getPlaystyles({ region, profileId, queueId }) {
  if (!region || !SERVICES_TO_REGIONS[region.toLowerCase()]) return null;
  if (!profileId) return null;

  const params = {
    region: region.toUpperCase(),
    leagueProfileId: profileId,
    queue: null,
  };

  if (queueId) {
    const queueSymbol =
      QueueSymbol(queueId) === QUEUE_SYMBOLS.custom
        ? QUEUE_SYMBOLS.rankedSoloDuo
        : QueueSymbol(queueId);
    params.queue = QUEUE_SYMBOL_TO_OBJECT[queueSymbol].gql;
  } else {
    delete params.queue;
  }

  return queryGQL(
    appURLs.LOL_LEAGUE_PLAYER,
    GraphQLTemplates.playstyles,
    params,
  );
}

export default function ({
  region,
  profileId,
  queueId,
  gameName,
  tagLine,
  path,
  options = {},
}: {
  region: string;
  profileId: string;
  queueId?: string;
  gameName: string;
  tagLine: string;
  path?: string[];
  options: object;
}) {
  return getData(
    getPlaystyles({ region, profileId, queueId }),
    PlaystylesModel,
    path || [
      "lol",
      "playerStyle",
      getDerivedId(region, null, gameName, tagLine),
    ],
    {
      ...options,
    },
  );
}
